import { UserRoles } from './userRole';


export const getRolePrefix = (roleName: string): string => {
  if (!roleName) return '';
  return '/' + roleName.toLowerCase().replace(/\s+/g, '-');
};

export const RoutesLink = {
  login: '/',
  signUp: '/join-now',
  forgotPassword: '/forgot-password',
  verifyOtp: '/verify-otp',
  resetPassword: '/reset-password',
  forbidden_403: '/forbidden_403',
  // private pages — prefix prepended dynamically at route registration & navigation
  dashboard: '/dashboard',
  stores: '/store',
  AddStore: '/store/add',
  EditStore: '/store/edit/:id',
  storeDetails: '/store/:id',
  Category: '/category',
  Varients: '/varients',
  AddVarients: '/varients/add',
  EditVarients: '/varients/edit/:id',
  AddOns: '/addons',
  AddAddOns: '/addons/add',
  EditAddOns: '/addons/edit/:id',
  Products: '/products',
  ImportProducts: '/products/import',
  AddProduct: '/products/add',
  EditProduct: '/products/edit/:id',
  ViewProduct: '/products/view/:id',
  Discount: '/discounts',
  AddDiscount: '/discounts/add',
  EditDiscount: '/discounts/edit/:id',
  ViewDiscount: '/discounts/view/:id',
  Coupons: '/coupons',
  AddCoupon: '/coupons/add',
  EditCoupon: '/coupons/edit/:id',
  ViewCoupon: '/coupons/view/:id',
  Settings: '/settings',
  Orders: '/orders',
  ViewOrders: '/orders/view/:id',
  Notifications: '/notifications',
  CreateNotification: '/notifications/create',
  Drivers: '/drivers',
  AddDriver: '/drivers/add',
  EditDriver: '/drivers/edit/:id',
  DriverDetails: '/drivers/:id',
  Customers: '/customers',
  CustomerDetails: '/customers/:id',
  LiveOrders: '/live-orders',
  Roles: '/roles',
  AddRole: '/roles/add',
  EditRole: '/roles/edit/:id',
  ViewRole: '/roles/view/:id',
  Staffs: '/staffs',
  AddStaff: '/staffs/add',
  EditStaff: '/staffs/edit/:id',
  Reviews: '/reviews',
  ReviewDetails: '/reviews/:id',
  HomeLayout: '/home-layout',
  Tags: '/tags',
  CashSettlement: '/cash-settlement',
  StoreSettlements: '/store-settlements',
  CreateStoreSettlement: '/store-settlements/create',
  Zones: '/zones',
  AddZone: '/zones/add',
  EditZone: '/zones/edit/:id',
  Return: '/return',
  ViewReturn: '/return/view/:id',
  ReturnReasons: '/return-reasons',
  Analytics: '/analytics',
  payouts: '/payouts',
  // public legal & information pages
  faq: '/faq',
  disclaimer: '/disclaimer',
  privacyPolicy: '/privacy-policy',
  returnPolicy: '/cancellation-return-refund-policy',
  returnPolicyAlias: '/return-policy',
  termsAndConditions: '/terms-and-conditions',
};

